import { Component, Injector, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { LivreBlancPage, LivreBlancQuery } from '@b2b-app/b2b-core';
import { ConcilioComponent } from '@conciliome/concilio-core';

@Component({
  selector: 'b2b-ui-livre-blanc',
  templateUrl: './b2b-livre-blanc.component.html',
  styleUrls: ['./b2b-livre-blanc.component.scss'],
})
export class B2bLivreBlancComponent extends ConcilioComponent implements OnInit {
  content$ = this.lvQuery.content$;
  livresblanc$ = this.lvQuery.livresblanc$;

  constructor(injector: Injector, private lvQuery: LivreBlancQuery, private meta: Meta, private titleService: Title) {
    super(injector);
    this.addSubscription(
      this.content$.subscribe((value) => {
        this.updateTags(value);
      })
    );
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.livresblanc$ = this.livresblanc$.pipe(
      map((data) => {
        if (data) {
          data?.sort((a, b) => new Date(b.publishedDate).getTime() - new Date(a.publishedDate).getTime());
        }
        return data;
      })
    );
  }

  updateTags(content: LivreBlancPage) {
    if (content && content.metas) {
      content.metas.forEach(({ name, value }) => {
        if (name === 'head' || name === 'headTitle') {
          this.titleService.setTitle(value || '');
        } else {
          this.meta.updateTag({ name, content: value });
          this.meta.updateTag({ name: `og:${name}`, content: value });
        }
      });
    }
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
}
